import React from 'react'
import PropTypes from 'prop-types'
import { motion } from 'framer-motion'

import { productByType } from 'utils/products'

function Product({ className, imageClassName, name, reverse }) {
  const y = reverse ? [-15, 30, -15] : [30, -15, 30]

  return (
    <div className={className}>
      <motion.div
        animate={{
          y
        }}
        transition={{
          duration: 3,
          ease: 'easeInOut',
          times: [0, 0.2, 0.5, 0.8, 1],
          repeat: Infinity,
          repeatDelay: 0
        }}
      >
        <img className={imageClassName} src={productByType({ type: name })} alt="Product" />
      </motion.div>
    </div>
  )
}

Product.propTypes = {
  className: PropTypes.string,
  imageClassName: PropTypes.string,
  name: PropTypes.string.isRequired,
  reverse: PropTypes.bool
}

Product.defaultProps = {
  className: '',
  imageClassName: '',
  reverse: false
}

export default Product
